var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"merchant-settled"},[_c('EsHeaderView'),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"merchant-settled-header"}),_c('div',{staticClass:"merchant-settled-content app-container"},[(!_vm.next)?_c('AgreeTextView'):_c('BusinessInforView')],1),_c('EsFooterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }